<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- main -->
    <b-row>
      <b-col lg="12">
        <!-- 查询条件 -->
        <b-card>
          <b-row>
            <b-col lg="4">
              <b-form-group
                label="Country"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="country-name"
              >
                <b-form-select
                  v-model="search_condition.id"
                  :options="types.allCountry"
                  value-field="id"
                  text-field="countryName"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                label="City"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="city-name"
              >
                <b-form-input
                  id="city-name"
                  v-model="search_condition.cityName"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                label="Region Encoding"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="cityEncoding"
              >
                <b-form-input
                  id="cityEncoding"
                  v-model="search_condition.cityEncoding"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                label="Status"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="status"
              >
                <b-form-select
                  v-model="search_condition.isDelete"
                  :options="types.statuss"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-button variant="primary" @click="search()">Search</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <!-- table -->
          <b-button v-has="'regionManage::Create'" @click="gotoAdd" variant="primary">Create</b-button>
          <div class="table-responsive mb-0">
            <b-table
              show-empty
              empty-text="no records"
              id="device-table"
              head-variant="light"
              ref="table"
              :busy="isBusy"
              :striped="true"
              :items="provider"
              :fields="fields"
              :per-page="search_condition.pageSize"
              :current-page="search_condition.pageNum"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-includedfields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(index)="data">{{
                data.index +
                  (search_condition.pageNum - 1) * search_condition.pageSize +
                  1
              }}</template>

              <template v-slot:cell(actions)="row">
                <b-button
                  v-has="'regionManage::Modify'"
                  size="sm"
                  variant="info"
                  @click="edit(row.item, row.index, $event.target)"
                  class="mr-1"
                  >Modify</b-button
                >

                <b-button
                  v-if="row.item.isDelete"
                  v-has="'regionManage::Disable'"
                  size="sm"
                  variant="danger"
                  @click="enableOrDisable(row.item, row.index, $event.target)"
                  class="mr-1"
                  >Disable</b-button
                >

                <b-button
                  v-else
                  v-has="'regionManage::Enable'"
                  size="sm"
                  variant="primary"
                  @click="enableOrDisable(row.item, row.index, $event.target)"
                  class="mr-1"
                  >Enable</b-button
                >
              </template>
            </b-table>
          </div>
          <!-- end table -->
          <!-- pagination -->
          <b-row v-if="has_data">
            <b-col>
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination mb-0" v-if="rows != 0">
                  <b-pagination
                    ref="page"
                    v-model="search_condition.pageNum"
                    :per-page="10"
                    :total-rows="rows"
                    aria-controls="table"
                  ></b-pagination>
                </ul>
              </div>
            </b-col>
          </b-row>
          <!-- end pagination -->
        </b-card>
      </b-col>
    </b-row>
    <!-- end main -->
  </Layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Flavor List component
 */
export default {
  components: {
    DatePicker,
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Region Manage",
      items: [
        {
          text: "UNI-CORE",
          // href: "/"
        },
        {
          text: "Data Dictionary",
          // href: "/"
        },
        {
          text: "Region Manage",
          active: true,
        },
      ],
      tableData: [],
      totalRows: 0,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "index", label: "#", class: "text-center" },
        {
          key: "countryName",
          label: "Country",
          class: "text-center",
        },
        {
          key: "cityName",
          label: "City",
          class: "text-center",
        },
        {
          key: "cityEncoding",
          label: "Region Encoding",
          class: "text-center",
        },
        {
          key: "isDelete",
          label: "Status",
          formatter: (value) => {
            return value == 1 ? "Enabled" : "Disabled";
          },
        },
        { key: "remarks", label: "Notes", class: "text-center" },
        { key: "actions", label: "Opreration", class: "text-center" },
      ],
      search_condition: {
        pageNum: 1,
        pageSize: 10,
        id: "",
        cityName: "",
        cityEncoding: "",
        isDelete: "",
      },
      types: {
        statuss: [
          { text: "Please select", value: "", disabled: false },
          { text: "Enabled", value: 1, disabled: false },
          { text: "Disabled", value: 0, disabled: false },
        ],
        allCountry: [{ id: "", countryName: "Please select" }],
      },
      isBusy: false,
      has_data: false,
    };
  },
  computed: {
    /**
     * 计算rows
     */
    rows() {
      return this.totalRows;
    },
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.$api.Dropdown.selectAllCountryName().then((res) => {
        if (res.success) {
          this.types.allCountry = this.types.allCountry.concat(res.data);
        } else {
          if(res.message){
              this.$bvToast.toast(res.message);
            }
        }
      });
    },
    provider(ctx) {
      this.isBusy = true;
      return this.$api.Flavor.areaList(this.search_condition, ctx)
        .then((x) => {
          this.isBusy = false;
          if (x.total) {
            this.has_data = true;
            this.totalRows = x.total;
            return x.data;
          } else {
            this.has_data = false;
            return [];
          }
        })
        .catch((e) => {
          this.isBusy = false;
          this.has_data = false;
          return [];
        });
    },
    search() {
      this.search_condition.pageNum = 1;
      this.$refs.table.refresh();
      //this.$bvToast.toast(JSON.stringify(this.search_condition));
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.search_condition.pageNum = 1;
    },
    gotoAdd() {
      this.$router.push("regionAdd");
    },
    edit(item, index, button) {
      this.$router.push({ name: "regionEdit", params: item });
    },
    // 停用启用
    enableOrDisable(a, b, c) {
      this.$api.Flavor.areaEnableOrDisable({
        id: a.id,
        isDelete: a.isDelete === 0 ? 1 : 0,
      }).then((res) => {
        if(res.message){
              this.$bvToast.toast(res.message);
            }
        if (res.success) {
          this.$refs.table.refresh();
        }
      });
    },
  },
};
</script>
